import { render, staticRenderFns } from "./GoodsSkuList.vue?vue&type=template&id=4f921317&"
import script from "./GoodsSkuList.vue?vue&type=script&lang=js&"
export * from "./GoodsSkuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports